import { render, staticRenderFns } from "./AuthNewPassForm.vue?vue&type=template&id=6288ce3e&scoped=true&"
import script from "./AuthNewPassForm.vue?vue&type=script&lang=js&"
export * from "./AuthNewPassForm.vue?vue&type=script&lang=js&"
import style0 from "./AuthNewPassForm.vue?vue&type=style&index=0&id=6288ce3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6288ce3e",
  null
  
)

export default component.exports